import {
  CheckIcon,
  ExclamationCircleIcon,
  ExclamationTriangleIcon,
} from "@heroicons/react/24/solid";
import React from "react";
import Button from "../../../components/form/Button";
import LoadingSpinner from "../../../components/loaders/LoadingSpinner";
import GoogleDocsSVG from "../../../assets/svg/google-docs.svg";
import {
  GOOGLE_EXPORT_LABELS,
  GoogleExportStatus,
  useGoogleDocExport,
} from "./useGoogleDocExport";

// the label slides open on hover (same as the copy button); full class names so Tailwind keeps them
const LABEL_WIDTHS: Record<GoogleExportStatus, string> = {
  idle: "group-hover:w-[140px]",
  exporting: "group-hover:w-[80px]",
  done: "group-hover:w-[64px]",
  error: "group-hover:w-[184px]",
  reauth: "group-hover:w-[216px]",
};

const ArticleExportToDrive = ({ articleId }: { articleId: string }) => {
  const { view, run } = useGoogleDocExport(articleId);

  const renderIcon = () => {
    switch (view) {
      case "exporting":
        return <LoadingSpinner size="16px" />;
      case "done":
        return <CheckIcon className="w-4 h-4 text-green-600" />;
      case "error":
        return <ExclamationCircleIcon className="w-4 h-4 text-red-500" />;
      case "reauth":
        // Google Docs logo with a warning badge: no working Google Docs destination yet
        return (
          <span className="relative flex items-center justify-center w-4 h-4">
            <img
              src={GoogleDocsSVG}
              alt="google-docs-logo"
              className="h-3.5 w-auto"
            />
            <ExclamationTriangleIcon className="absolute -right-1.5 -bottom-1.5 w-3 h-3 text-amber-500" />
          </span>
        );
      default:
        return (
          <img
            src={GoogleDocsSVG}
            alt="google-docs-logo"
            className="h-3.5 w-auto"
          />
        );
    }
  };

  return (
    <Button
      paddingZero
      variant={view === "exporting" ? "disabled" : "transparent"}
      className="group h-auto p-2 min-h-6 min-w-6 text-sm text-gray-400 cursor-pointer bg-gray-100 hover:bg-gray-100 hover:text-gray-500 rounded-full flex items-center justify-center"
      onClick={run}
    >
      <div
        className={`flex items-center w-0 h-4 ${LABEL_WIDTHS[view]} transition-all ease-linear duration-200 overflow-hidden`}
      >
        <div className="hidden opacity-0 group-hover:flex group-hover:opacity-100 text-xs flex-nowrap whitespace-nowrap mx-1">
          {GOOGLE_EXPORT_LABELS[view]}
        </div>
      </div>
      {renderIcon()}
    </Button>
  );
};

export default ArticleExportToDrive;
